var _rect, _rect2, _g, _rect3, _rect4, _circle, _circle2, _circle3, _rect5, _rect6, _rect7, _rect8, _rect9, _g2, _path, _g3, _path2, _g4, _circle4, _circle5, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebhookTooTipIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 114,
    viewBox: "0 0 118 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_1353_7439)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 100,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 12,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#137FFD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1353_7439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4569 20.5455C19.9361 21.2839 18.9195 21.4694 18.1847 20.9557C17.4534 20.442 17.2822 19.4183 17.7959 18.6728C17.9396 18.4644 18.1298 18.2921 18.3513 18.1695C18.5729 18.047 18.8199 17.9775 19.0729 17.9665L19.0907 18.4766C18.7661 18.5016 18.4522 18.6692 18.2489 18.9617C17.8922 19.4754 18.0028 20.1674 18.4914 20.5134C18.9837 20.8558 19.6721 20.7238 20.0288 20.2138C20.1394 20.0532 20.2036 19.8785 20.2286 19.7001V19.3398L22.219 19.3256L22.244 19.2863C22.433 18.9582 22.8432 18.844 23.1642 19.0295C23.2411 19.0745 23.3083 19.1341 23.3621 19.2051C23.4159 19.276 23.4551 19.3568 23.4776 19.443C23.5002 19.5291 23.5055 19.6188 23.4934 19.707C23.4812 19.7952 23.4518 19.8801 23.4068 19.9569C23.2178 20.2815 22.804 20.3957 22.4829 20.2102C22.3367 20.1281 22.2333 19.9962 22.1869 19.8464L20.7351 19.8535C20.6922 20.1012 20.5974 20.337 20.4569 20.5455ZM23.0537 17.9986C23.9561 18.1092 24.5982 18.9189 24.4876 19.8071C24.377 20.6989 23.5566 21.3302 22.6542 21.2197C22.4036 21.1904 22.163 21.1042 21.9509 20.9675C21.7388 20.8309 21.5608 20.6475 21.4307 20.4313L21.873 20.1745C21.9645 20.3162 22.0861 20.436 22.2291 20.5254C22.3721 20.6148 22.5331 20.6716 22.7005 20.6917C23.3248 20.7666 23.8777 20.3422 23.9526 19.7465C24.0275 19.1508 23.5852 18.605 22.9681 18.5301C22.7754 18.5087 22.59 18.5337 22.4223 18.5943L22.1191 18.7513L21.1988 17.0498H21.1203C20.9408 17.0446 20.7706 16.9685 20.6469 16.8382C20.5233 16.7078 20.4562 16.5338 20.4604 16.3542C20.4711 15.9833 20.7922 15.6943 21.1667 15.7086C21.5413 15.73 21.8373 16.0332 21.8266 16.4042C21.8195 16.5611 21.7588 16.7038 21.6625 16.8144L22.3403 18.0664C22.5614 17.9951 22.804 17.9701 23.0537 17.9986ZM19.6686 17.0284C19.3119 16.1902 19.69 15.2306 20.5139 14.8811C21.3415 14.5315 22.2975 14.9274 22.6542 15.7657C22.8646 16.2544 22.8218 16.7894 22.5828 17.2175L22.1405 16.9606C22.2903 16.6717 22.3153 16.3186 22.1726 15.9868C21.9301 15.4161 21.2844 15.1415 20.7315 15.3733C20.1751 15.6087 19.9254 16.2651 20.1679 16.8358C20.2678 17.0712 20.4355 17.2531 20.6388 17.3744L20.7779 17.4493L19.6828 19.2293C19.6935 19.2471 19.7078 19.2685 19.7185 19.297C19.8933 19.6216 19.772 20.0318 19.4438 20.2066C19.1192 20.3814 18.709 20.253 18.5307 19.9177C18.3559 19.586 18.4772 19.1758 18.8053 19.001C18.9445 18.9261 19.0978 18.9082 19.2441 18.9403L20.0681 17.5956C19.9004 17.4422 19.7577 17.2496 19.6686 17.0284Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 16,
    width: 70,
    height: 4,
    rx: 1,
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ddd_1353_7439)"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 63,
    width: 100,
    height: 61,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 69,
    r: 1,
    fill: "#FC5F55"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 69,
    r: 1,
    fill: "#FDBB40"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 69,
    r: 1,
    fill: "#34C449"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.8
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 74,
    width: 88,
    height: 4,
    rx: 1,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 82,
    width: 52,
    height: 4,
    rx: 1,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 90,
    width: 69,
    height: 4,
    rx: 1,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.8
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 98,
    width: 88,
    height: 4,
    rx: 1,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 106,
    width: 69,
    height: 4,
    rx: 1,
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1353_7439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.7348 62.2652C58.8813 62.4116 59.1187 62.4116 59.2652 62.2652L61.6517 59.8787C61.7981 59.7322 61.7981 59.4948 61.6517 59.3484C61.5052 59.2019 61.2678 59.2019 61.1213 59.3484L59 61.4697L56.8787 59.3484C56.7322 59.2019 56.4948 59.2019 56.3483 59.3484C56.2019 59.4948 56.2019 59.7322 56.3483 59.8787L58.7348 62.2652ZM58.625 54V55.5H59.375V54H58.625ZM58.625 56.5V59.5H59.375V56.5H58.625ZM58.625 60.5V62H59.375V60.5H58.625Z",
    fill: "#7DB9FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.7348 62.2652C58.8813 62.4116 59.1187 62.4116 59.2652 62.2652L61.6517 59.8787C61.7981 59.7322 61.7981 59.4948 61.6517 59.3484C61.5052 59.2019 61.2678 59.2019 61.1213 59.3484L59 61.4697L56.8787 59.3484C56.7322 59.2019 56.4948 59.2019 56.3483 59.3484C56.2019 59.4948 56.2019 59.7322 56.3483 59.8787L58.7348 62.2652ZM58.625 54V57.3333H59.375V54H58.625ZM58.625 58.6667V62H59.375V58.6667H58.625Z",
    fill: "#42CFEF"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1353_7439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59 30L59 36",
    stroke: "#7DB9FF",
    strokeWidth: 0.75,
    strokeDasharray: "3 1"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30L59 36",
    stroke: "#42CFEF",
    strokeWidth: 0.75,
    strokeDasharray: "4 1"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1353_7439)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 58.751,
    cy: 44.75,
    r: 8.25,
    stroke: "#7DB9FF",
    strokeWidth: 0.75,
    strokeMiterlimit: 3.99933,
    strokeDasharray: "3 1"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.751,
    cy: 44.75,
    r: 8.25,
    stroke: "#42CFEF",
    strokeWidth: 0.5,
    strokeMiterlimit: 3.99933,
    strokeDasharray: "3 1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.75,
    cy: 44.75,
    r: 6.75,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7544 40.7426L63.2575 40.2457C63.2388 40.227 63.2153 40.2188 63.1907 40.2188C63.1661 40.2188 63.1427 40.2281 63.1239 40.2457L62.2321 41.1375C61.8444 40.8748 61.3867 40.7348 60.9184 40.7355C60.3184 40.7355 59.7184 40.9641 59.2602 41.4223L58.0661 42.6164C58.0487 42.634 58.0389 42.6578 58.0389 42.6826C58.0389 42.7074 58.0487 42.7312 58.0661 42.7488L61.2501 45.9328C61.2688 45.9516 61.2923 45.9598 61.3169 45.9598C61.3403 45.9598 61.3649 45.9504 61.3837 45.9328L62.5778 44.7387C63.3852 43.9301 63.4802 42.6797 62.8626 41.768L63.7544 40.8762C63.7907 40.8387 63.7907 40.7789 63.7544 40.7426ZM59.7841 45.4055C59.7665 45.388 59.7427 45.3782 59.7179 45.3782C59.6931 45.3782 59.6693 45.388 59.6516 45.4055L58.8712 46.1859L57.813 45.1277L58.5946 44.3461C58.6309 44.3098 58.6309 44.25 58.5946 44.2137L58.1681 43.7871C58.1504 43.7697 58.1266 43.7599 58.1018 43.7599C58.077 43.7599 58.0533 43.7697 58.0356 43.7871L57.254 44.5687L56.7501 44.0648C56.7413 44.0561 56.7309 44.0492 56.7194 44.0446C56.708 44.0399 56.6957 44.0377 56.6833 44.0379C56.6599 44.0379 56.6352 44.0473 56.6165 44.0648L55.4235 45.259C54.6161 46.0664 54.5212 47.318 55.1388 48.2297L54.247 49.1215C54.2295 49.1391 54.2197 49.1629 54.2197 49.1877C54.2197 49.2125 54.2295 49.2363 54.247 49.2539L54.7438 49.7508C54.7626 49.7695 54.786 49.7777 54.8106 49.7777C54.8352 49.7777 54.8587 49.7684 54.8774 49.7508L55.7692 48.859C56.1641 49.1273 56.6235 49.2609 57.0829 49.2609C57.6829 49.2609 58.2829 49.0324 58.7411 48.5742L59.9352 47.3801C59.9716 47.3438 59.9716 47.284 59.9352 47.2477L59.4313 46.7438L60.213 45.9621C60.2493 45.9258 60.2493 45.866 60.213 45.8297L59.7841 45.4055Z",
    fill: "#394353"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_1353_7439",
    x: 0,
    y: 0,
    width: 118,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1353_7439"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1353_7439"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1353_7439",
    result: "effect2_dropShadow_1353_7439"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1353_7439",
    result: "effect3_dropShadow_1353_7439"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1353_7439",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddd_1353_7439",
    x: 0,
    y: 57,
    width: 118,
    height: 79,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1353_7439"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1353_7439"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1353_7439",
    result: "effect2_dropShadow_1353_7439"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1353_7439",
    result: "effect3_dropShadow_1353_7439"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1353_7439",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1353_7439",
    x: 48.2383,
    y: 46,
    width: 21.5234,
    height: 24.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_1353_7439"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1353_7439",
    x: 50.625,
    y: 22,
    width: 16.75,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_1353_7439"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1353_7439",
    x: 47.126,
    y: 33.125,
    width: 23.25,
    height: 23.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_1353_7439"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1353_7439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(17 14)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebhookTooTipIcon);
export default __webpack_public_path__ + "static/media/webhookTooTipIcon.a0e6cfbcaabd99fe1416b4673a3184d6.svg";
export { ForwardRef as ReactComponent };